var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0a57d63b9e35e0f1e735819c34ee9552d8fb5f28"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 415
// module chunks = 10